import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { REACT_APP_GQL_API } from "src/config/environment"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import { useProfile } from "src/shared/hooks/useProfile"
import { buildConfigAuthorizationUrl } from "src/utils/configAuthorization"
import { isActiveSession } from "src/utils/session"

function RedirectSuscripcion() {
    const { pathname } = useLocation()
    const { hotel_id } = useProfile()
    const navigate = useNavigate()

    const getSessionStore = (key: string) => sessionStorage.getItem(key) || ""

    const getAmbiente = () => {
        const url = `${REACT_APP_GQL_API || ""}`
        const path = url.split("//")?.[1]?.split(".")?.[0] || ""
        return path || "dev"
    }

    const getUrl = (): string => {
        if (process.env.NODE_ENV === "production") {
            if (getAmbiente() === "app") {
                return "https://app-config.easyroom.io"
            } else {
                return ""
            }
        } else {
            return "http://localhost:5173"
        }
    }

    const handleConfig = () => {
        const url = getUrl()
        if (url) {
            const authorizationUrl = buildConfigAuthorizationUrl(
                "CONFIGURACION_HOTEL",
                hotel_id || getSessionStore("hotel_id"),
                url,
                process.env.NODE_ENV,
                "suscripcion"
            )
            if (authorizationUrl) {
                window.location.href = authorizationUrl
            }
        }
    }

    useEffect(() => {
        if (isActiveSession() && hotel_id) {
            handleConfig()
        } else {
            const hotel_id = pathname.split("/redirect/suscripcion/")?.["1"] || "none"
           
            sessionStorage.setItem("@redirect", "suscripcion")
            sessionStorage.setItem("@redirect-hotel_id", hotel_id)
            navigate("/", { replace: true })
        }
    }, [hotel_id])


    return (
        <LoaderComponent visible />
    )
}

export default RedirectSuscripcion